import { Component, Prop, Vue } from 'vue-property-decorator';
import { CONTRIBUTION_LEVELS } from '@/constants';
import ContributionLevelIcon from '@/components/common/contribution-level-icon/ContributionLevelIcon.vue';

@Component({
  components: {
    ContributionLevelIcon
  }
})
export default class LevelRangeDetails extends Vue {
  @Prop({ default: false }) isIcon: boolean;
  
  private levels = Object.values(CONTRIBUTION_LEVELS);
  private levelRangeDetailsShown = false;

  isMaxSafeIntegerNumber(num: number): boolean {
    return num === Number.MAX_SAFE_INTEGER;
  }
}
